import { IoClose } from "react-icons/io5";
import dateFormat from "../../../functions/dateFormat";
import StatusInvoices from "./StatusInvoices";
import Massage from "../../design/Massage";
import FetchMassage from "../../../faetures/FetchMassage";
import { useState } from "react";


function InvoicesData({ data, openNumDocket }) {
    const [massage, setMassage] = useState({ open: false, numInvoices: 0, status: null, cancel: false });
    const [massageFetch, setMassageFetch] = useState({ open: false, url: "", text: "" });
    const Admin = sessionStorage.getItem('admin') === 'admin';

    const types = ["מזומן", "אשראי", "העברה", "צ'ק", "שובר"];
    const status = { 1: "אושר", 0: "ממתין לאישור", 2: "נדחה", 3: "מחיקה" };

    function clickAfterAgree() {
        if (massage.cancel) {
            setMassageFetch({ open: true, url: `invoices/delete?num=${massage.numInvoices}`, text: "" });

        } else {
            setMassageFetch({ open: true, url: `invoices/updateStatus?num=${massage.numInvoices}&status=${massage.status}`, text: "" });
        }
        setMassage({ open: false, numInvoices: 0, status: null, cancel: false })
    }


    const massageFunResolve = (resolve) => {
        if (resolve[0] === 0) {
            setMassageFetch({ open: true, text: "שגיאה", url: "" });
        } else if (resolve[0] === 2) {
            setMassageFetch({ open: true, text: "קבלה עודכנה בהצלחה", url: "" });
        } else if (resolve[0] === 4) {
            setMassageFetch({ open: true, text: "אין אפשרות למחיקה", url: "" });
        }
    }

    const handelChange = (status, value) => {
        setMassage({ open: true, numInvoices: value, status: status, cancel: false });
    }

    return (<>
        <div className="InvoicesListTable">

            {
                Object.keys(data).length > 0 ?

                    <table>
                        <thead>
                            <tr>
                                {["מס'", "מס' קבלה", "מס' דוקט", "שם", "תאריך", "סכום בשקלים", "סכום בדולרים", "סוג תשלום", "סטטוס", "ביטול", "פרטי תשלום"].map((value, key) => (
                                    <th key={key}> {value} </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {
                                Object.values(data).map((value, key) => (
                                    <tr key={key}>
                                        <td key={1}> {key + 1} </td>
                                        <td key={10}> {value[0].toString().padStart(7, '0')} </td>
                                        <td key={11} className="docket_number" onClick={() => openNumDocket(value[1])}> {value[1]} </td>
                                        <td key={2}> {value[3]} </td>
                                        <td key={3}> {dateFormat(value[4])} </td>
                                        <td key={4}> {value[7]}₪ </td>
                                        <td key={5}> {value[8]}$ </td>
                                        <td key={6}> {types[value[5]]} </td>

                                        <td key={7}>
                                            {
                                                Admin ?
                                                    <StatusInvoices
                                                        value={value[10]}
                                                        onChange={(status) => handelChange(status, value[0])}
                                                    /> :
                                                    status[value[10]]
                                            }
                                        </td>

                                        {
                                            Admin ?
                                                <td key={8}> <IoClose onClick={() => setMassage({ open: true, numInvoices: value[0], status: null, cancel: true })} /> </td> : ''
                                        }

                                        <td key={9}>
                                            {value[6]}
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                    :
                    <p className={"no-results"}>אין תוצאות</p>
            }

            {massage.open &&
                <Massage
                    text={massage.cancel ?
                        `האם אתב בטוח שברצונך למחוק קבלה מס' ${massage['numInvoices'].toString().padStart(7, '0')}` :
                        `האם אתה בטוח שברצונך לעדכן ססטוס.(${status[massage.status]}) לקבלה מס' ${massage['numInvoices'].toString().padStart(7, '0')}`
                    }
                    setClose={() => setMassage({ open: false, numInvoices: 0, status: null, cancel: false })}
                    buttonAgree={() => clickAfterAgree()}
                />
            }

            {
                massageFetch.open &&
                <FetchMassage
                    url={massageFetch.url}
                    text={massageFetch.text}
                    fun={massageFunResolve}
                    setClose={() => setMassageFetch({ open: false })}
                    setMassage={setMassageFetch}
                />
            }
        </div>

    </>)
}


export default InvoicesData;